
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-monitoring",
      function () {
        return require("private-next-pages/request-monitoring.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-monitoring"])
      });
    }
  